import type { IconNames, CategoryType } from '@/types/common/icon';

/**
 * ポストグループ
 */
export type PostGroupType = {
  /** キー */
  key: string,
  /** タイトル */
  title: string
}

/**
 * postGroups
 */
export const postGroups: PostGroupType[] = [
  { key: 'main', title: '連絡・お知らせ' },
  { key: 'sub', title: '記録・履歴' },
  { key: 'homepage', title: 'ホームページ' },
  { key: 'option', title: '登録・申請・その他' },
];

/** 家族などをメンバーとして登録する実装を入れる際は、以下をnurseryと同様にmemberコンテキストにいれる */
export const AUTH_ALL_ONLY_TYPE = [
  'news',
  'childNotebook',
  'photo',
  'notice',
  'attendContact',
  'attendHistory',
  'healthRecord',
  'measure',
  'blog',
  'openHomepage',
  'child',
  'childApply',
] as const;

/**
 * AuthAllType
 */
export type AuthAllType = typeof AUTH_ALL_ONLY_TYPE[number]; // | AuthMemberType;

/**
 * authAllInfomation
 */
export const authAllInfomation: {
  [key in AuthAllType]: {
    /** 名前 */
    name: string,
    /** 説明 */
    description: string,
    /** アイコン */
    icon: IconNames,
    /** 画像 */
    image: string,
    /** カテゴリ */
    category: CategoryType,
    /** 子どもが必要か */
    isChildNecessary: boolean,
    /** 施設は必要か */
    isFacilityNecessary: boolean,
    /** ホームページは必要か */
    isHomepageNecessary: boolean,
  }
} = {
  /** お知らせ */
  news: {
    name: 'お知らせ',
    description: '',
    icon: 'Email',
    image: 'mail.png',
    category: 'main',
    isChildNecessary: true,
    isFacilityNecessary: true,
    isHomepageNecessary: false,
  },
  /** 連絡帳 */
  childNotebook: {
    name: '連絡帳',
    description: '',
    icon: 'EditNote',
    image: 'notebook.png',
    category: 'main',
    isChildNecessary: true,
    isFacilityNecessary: true,
    isHomepageNecessary: false,
  },
  /** 写真 */
  photo: {
    name: '写真販売',
    description: '',
    icon: 'PhotoCamera',
    image: 'camera.png',
    category: 'main',
    isChildNecessary: true,
    isFacilityNecessary: true,
    isHomepageNecessary: false,
  },
  /** 掲示板 */
  notice: {
    name: '掲示板',
    description: '',
    icon: 'Article',
    image: 'notice.png',
    category: 'main',
    isChildNecessary: true,
    isFacilityNecessary: true,
    isHomepageNecessary: false,
  },
  /** 出席連絡 */
  attendContact: {
    name: '登降園連絡',
    description: '',
    icon: 'Phone',
    image: 'phone.png',
    category: 'main',
    isChildNecessary: true,
    isFacilityNecessary: true,
    isHomepageNecessary: false,
  },
  /** 登降園履歴 */
  attendHistory: {
    name: '登降園履歴',
    description: '',
    icon: 'History',
    image: 'time.png',
    category: 'sub',
    isChildNecessary: true,
    isFacilityNecessary: true,
    isHomepageNecessary: false,
  },
  /** 健康記録 */
  healthRecord: {
    name: '健康記録',
    description: '',
    icon: 'Accessibility',
    image: 'temperature.png',
    category: 'sub',
    isChildNecessary: true,
    isFacilityNecessary: true,
    isHomepageNecessary: false,
  },
  /** 成長記録 */
  measure: {
    name: '成長記録',
    description: '',
    icon: 'Speed',
    image: 'measure.png',
    category: 'sub',
    isChildNecessary: true,
    isFacilityNecessary: true,
    isHomepageNecessary: false,
  },
  /** 園内ブログ */
  blog: {
    name: '園内ブログ',
    description: '',
    icon: 'Newspaper',
    image: 'blog.png',
    category: 'homepage',
    isChildNecessary: true,
    isFacilityNecessary: true,
    isHomepageNecessary: false,
  },
  /** ホームページ */
  openHomepage: {
    name: 'ホームページ',
    description: '',
    icon: 'Newspaper',
    image: 'homepage.png',
    category: 'homepage',
    isChildNecessary: true,
    isFacilityNecessary: true,
    isHomepageNecessary: true,
  },
  /** 子ども情報 */
  child: {
    name: '子ども情報',
    description: '',
    icon: 'ChildCare',
    image: 'child.png',
    category: 'option',
    isChildNecessary: false,
    isFacilityNecessary: false,
    isHomepageNecessary: false,
  },
  /** 施設申請 */
  childApply: {
    name: '施設申請',
    description: '',
    icon: 'Assignment',
    image: 'paper.png',
    category: 'option',
    isChildNecessary: true,
    isFacilityNecessary: false,
    isHomepageNecessary: false,
  },
};
